.ke{min-width:14rem;}